// Small field pieces shared by the bid forms. Declared at module scope — a
// component declared inside another loses focus after one character (§17b).

import type { ReactNode } from 'react';

export const INPUT =
  'w-full rounded border border-tcs-border bg-tcs-field px-2 py-1.5 text-base text-tcs-text sm:text-sm';

export function Field({ label, hint, children, error }: { label: string; hint?: ReactNode; children: ReactNode; error?: string | null }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-tcs-text-secondary">{label}</span>
      {children}
      {hint && <span className="mt-1 block text-xs text-tcs-text-muted">{hint}</span>}
      {error && <span role="alert" className="mt-1 block text-xs text-st-danger-fg">{error}</span>}
    </label>
  );
}

export function SaveError({ text }: { text: string | null }) {
  if (!text) return null;
  return (
    <div role="alert" className="rounded border border-st-danger-border-strong bg-st-danger-bg px-3 py-2 text-sm text-st-danger-fg-strong">
      {text}
    </div>
  );
}

export function Section({ title, children, aside }: { title: string; children: ReactNode; aside?: ReactNode }) {
  return (
    <section className="rounded-xl border border-tcs-border bg-tcs-bg p-4 sm:p-5">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-base font-semibold text-tcs-text">{title}</h2>
        {aside}
      </div>
      {children}
    </section>
  );
}
